
import { Component, Vue } from 'vue-property-decorator'

/**
 * 文字列リンクの基底コンポーネント
 */
@Component
export default class LinkBase extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
